import React from 'react';

const LastSession = ({ data }) => {
  if (!data) return null;

  const { date, name, distance, duration, pace, avgHr, cadence, weather, efficiency, id } = data;

  return (
    <div className="bg-gray-800 rounded-xl p-6 border border-gray-700">
        <div className="flex justify-between items-start mb-4">
             <div>
                <h3 className="text-gray-400 text-xs uppercase tracking-wider">Last Session</h3>
                <p className="text-white font-semibold mt-1">{date}</p>
             </div>
             <a 
                href={`https://www.strava.com/activities/${id}`} 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-orange-500 hover:text-orange-400 text-sm"
             >
                View ↗
             </a>
        </div>

        <div className="grid grid-cols-2 gap-4 mb-4">
            <div>
                <p className="text-xs text-gray-500">Distance</p>
                <p className="text-xl font-bold text-white">{distance}</p>
            </div>
            <div>
                <p className="text-xs text-gray-500">Pace</p>
                <p className="text-xl font-bold text-white">{pace}</p>
            </div>
            <div>
                <p className="text-xs text-gray-500">Time</p>
                <p className="text-lg font-medium text-gray-300">{duration}</p>
            </div>
            <div>
                 <p className="text-xs text-gray-500">Avg HR</p>
                 <p className="text-lg font-medium text-gray-300">{avgHr} bpm</p>
            </div>
        </div>

        {efficiency && (
             <div className="bg-gray-900/50 p-3 rounded-lg mb-4 flex justify-between items-center">
                 <div>
                     <p className="text-xs text-gray-500">Efficiency Factor</p>
                     <p className="font-mono text-blue-300">{efficiency.ef || '-'}</p>
                 </div>
                 <div>
                     <p className="text-xs text-gray-500">Decoupling</p>
                     <p className={`font-mono ${parseFloat(efficiency.decoupling) > 5 ? 'text-red-400' : 'text-green-400'}`}>
                         {efficiency.decoupling || '-'}%
                     </p>
                 </div>
             </div>
        )}

        {weather && (
            <div className="border-t border-gray-700 pt-3 flex items-center gap-3 text-sm text-gray-400">
                <span>🌡️ {weather.temp}°C</span>
                <span>💧 {weather.humidity}%</span>
                <span>💨 {weather.wind} km/h</span>
            </div>
        )}
    </div>
  );
};

export default LastSession;
